module.exports = __webpack_public_path__ + "static/img/img_member_b.17529d47.png";